import { Button, Divider, Grid, Paper, Typography } from '@mui/material';
import { useState } from 'react';
import { useCompany } from '../../../providers';
import CheckInRange from './checkInRange';
import { convertDatesToArray } from './functions/convertDatesToArray';
import { loadCheckinData } from './functions/loadCheckinData';
import { processSelectedPeople } from './functions/processSelectedPeople';
import UserAutocomplete from './userAutocomplete';

const ReportParameters = ({ processing, setProcessing, setLoadedData, location }) => {
   const { company } = useCompany();
   const [selected, setSelected] = useState([]);
   const [startDate, setStartDate] = useState(null);
   const [endDate, setEndDate] = useState(null);
   const [error, setError] = useState(null);

   async function createReport() {
      if (!startDate || !endDate || selected.length === 0) {
         setLoadedData(null);
         setError('Please select users and a valid date range.');
         return;
      } else {
         setProcessing(true);
         const people = await processSelectedPeople(selected, location);
         const dates = convertDatesToArray(startDate, endDate);
         setError(null);

         try {
            const data = await loadCheckinData(people, dates, company);
            setLoadedData(data);
            setProcessing(false);
         } catch (error) {
            setError('Error loading data refresh the page and try again.');
            setLoadedData(null);
            setProcessing(false);
         }
      }
   }

   return (
      <Grid item xs={12} component={Paper} sx={{ p: 2 }}>
         <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Search parameters
         </Typography>
         <UserAutocomplete
            location={location}
            setSelected={setSelected}
            selected={selected}
         />
         <Typography variant="caption" sx={{ mt: 1 }}>
            Selected: {selected.length}
         </Typography>
         <Divider sx={{ my: 2 }} />
         <CheckInRange
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
         />
         {error && (
            <Typography color="error" variant="body2">
               {error}
            </Typography>
         )}
         <Button variant="outlined" onClick={() => createReport()}>
            Create Report
         </Button>
      </Grid>
   );
};

export default ReportParameters;
